import Component from '../abstracts/Component';

export default class SizeSelectorComponent extends Component {
  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      sizesBox: '[data-sizes]', // sizes box
      sizes: '[data-size]', // sizes
      trigger: '[data-sizes-trigger]', // for error
      sizeError: '[data-sizes-error]', // error div
      select: '[data-sizes-select]',
      dropdown: '[data-sizes-dropdown]',
      sizeSelected: '[data-size-selected]',
    };
  }

  get CLASSES() {
    return {
      selected: 'selected',
      show: 'show',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.clickOutside = this.clickOutside.bind(this);
    this.addToWishlistURL = "/action/ajax/wishlist-add";
    this.box = this.$component;
    this.sizesBox = this.$component.querySelector(this.SELECTORS.sizesBox);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.sizes);
    this.trigger = this.$component.querySelector(this.SELECTORS.trigger);
    this.sizeError = this.$component.querySelector(this.SELECTORS.sizeError);
    this.selected = this.$component.querySelector(this.SELECTORS.sizeSelected);
    this.sizeSelect = this.$component.querySelector(this.SELECTORS.select);
    this.sizeDropdown = this.$component.querySelector(this.SELECTORS.dropdown);
    this.isProductOnWishlist = this.$component.dataset.productIntoWishlist === 'true';
  }

  toggleDropdown() {
    this.trigger.classList.toggle('open');
    this.trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
    document.addEventListener('click', this.clickOutside);
    this.sizeDropdown.addEventListener('click', e => e.stopPropagation());
  }

  closeDropdown() {
    if(!this.trigger) return;
    this.trigger.classList.remove('open');
    document.removeEventListener('click', this.clickOutside);
  }

  clickOutside(e) {
    if (e.target != this.trigger) {
      this.closeDropdown();
    }
  }

  selectSize(size) {
    if (!size) return;
    // remove selected
    let prevSize = this.sizesBox.querySelector(
      this.SELECTORS.sizes + '.' + this.CLASSES.selected
    );
    if (prevSize) {
      prevSize.classList.remove(this.CLASSES.selected);
    }
    // add selected
    size.classList.add(this.CLASSES.selected);
    /*if (this.sizeSelect != null) {
      this.sizeSelect.value = size.dataset.value;
      this.selected.innerHTML = size.innerHTML;
      this.selected.dataset.unavailable = size.dataset.unavailable;
      this.closeDropdown();
    }*/
    if (this.selected){
      this.selected.innerHTML = size.innerHTML;
      this.selected.dataset.unavailable = size.dataset.unavailable;
    }
    this.closeDropdown();
  }

  cleanSelectSize() {
    // global
    let self = this;
    // clean selected class
    this.sizes.forEach(size => {
      size.classList.remove(self.CLASSES.selected);
    });
    if (this.sizeSelect != null) {
      this.sizeSelect.value = '';
    }
    if(this.selected) {
      this.selected.innerHTML = '';
    }
  }

  addToWishlistAfterChangeSize(productCode) {
    fetch(`${this.addToWishlistURL}?code=${productCode}`, {
      body: null,
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
    })
      .then(function(response) {
        if (response.ok) {
          console.log('OK', response.body);
        }
      })
      .catch(error => {
        console.error(
          'Failed to send request for add/remove wishlist',
          error.stack
        );
      });
  }

  bindEvents() {
    // trigger on sizes
    if (this.trigger != null) {
      this.trigger.addEventListener('click', () => {
        this.toggleDropdown();
      });
    }
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener('click', () => {
          const isSelected = size.classList.contains(this.CLASSES.selected);
          const isUnavailable = size.dataset.unavailable === 'true';
          const productCode = size.dataset.productCode;
          // put size
          this.selectSize(size);
          // if not available launch notify me event
          if (isUnavailable) {
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {
              box: this.box,
            });
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {
              box: this.box,
            });
          }
          // general event
          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {
            button: size,
          });
          if (!isSelected && !isUnavailable && this.isProductOnWishlist) {
            this.addToWishlistAfterChangeSize(productCode);
          }

          // reset error
          if (this.sizeError) {
            this.sizeError.innerHTML = '';
            this.sizeError.classList.remove(this.CLASSES.show);
          }
        });
      });
    }

    // on notify me ended reset select
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeended, () => {
      // reset value
      this.cleanSelectSize();
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      let sizeErrorBox = document.querySelector('[data-sizes-error=prod-'+e.payload.dataset.productCode+']');
      // put error
      if (sizeErrorBox && !sizeErrorBox.classList.contains(this.CLASSES.show)) {
        sizeErrorBox.classList.add(this.CLASSES.show);
        sizeErrorBox.innerHTML = e.payload.dataset.selectSize;
      }
    });
    //is product already into wishlist state toggled by wishlist add/remove events
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, () => {
      this.isProductOnWishlist = true;
    });
    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, () => {
      this.isProductOnWishlist = false;
    });
  }

  checkSizeSelected(){
    if(!this.selected) return;
    const selectedSize = this.selected.dataset['sizeSelected'];
    if(selectedSize){
      const size = this.sizesBox.querySelector(`[data-product-code="${selectedSize}"]`);
      console.log(size);

      this.selectSize(size);
    }
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    this.checkSizeSelected();
  }
}
